import React from 'react';

export function WidgetTokenIcon({color = '#fff'}) {
  return (
    <svg width="20" height="20" viewBox="0 0 100 125" fill={color}>
      <path d="M46.7,66.83l4.42,4.42a5,5,0,0,0,3.72,1.54h5.23v4.42a6,6,0,0,0,6,6h4.42v5.22A5.28,5.28,0,0,0,72,92.11l3.47,3.47A4.9,4.9,0,0,0,78.93,97H92.71a4.31,4.31,0,0,0,4.3-4.3h0V78.92a4.89,4.89,0,0,0-1.44-3.48L66.83,46.7A32.85,32.85,0,0,0,12.6,12.6,32.85,32.85,0,0,0,46.7,66.83Zm-29.85-50A26.85,26.85,0,0,1,60.57,46.28a3,3,0,0,0,.64,3.29L91,79.37V91H79.37l-2.93-2.93V81a3.86,3.86,0,0,0-3.86-3.86h0l-6.51,0V70.65a3.86,3.86,0,0,0-3.86-3.86H55.15l-5.58-5.58a3,3,0,0,0-3.29-.64A26.85,26.85,0,0,1,16.84,16.85ZM29.41,40.42a11,11,0,1,0-11-11A11,11,0,0,0,29.41,40.42Zm0-15.92a5,5,0,1,1-5,5A5,5,0,0,1,29.41,24.49Z " fill="currentColor"/>    
    </svg>
  );
}
